module.exports = __webpack_public_path__ + "static/media/select-courses-illustration.f81d747b.webp";